import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import { isPromoValidateButton, messageSuccessPayment } from '../../utils/helper'
import QRCode from 'react-qr-code'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { getConfigDetails } from '../../../../services/config'
// import { getConfigDetails } from '../../services/config'

function QRCodeComp(props) {
    const {paymentData, isMessage, isLicensePlate, screen} = props
    const [paymentResponse, setPaymentResponse] = useState(EMPTY_OBJECT)
    const [extendResponse, setExtendResponse] = useState(EMPTY_OBJECT)
    
    useEffect(() => {
        const paymentResponse = JSON.parse(localStorage.getItem('paymentRecipt'))
        const extendResponse = JSON.parse(localStorage.getItem('ExtendData'))

        setExtendResponse(extendResponse)
        setPaymentResponse(paymentResponse)
    }, [EMPTY_ARRAY])
    
    
    return (
        <Container>
            {screen == 'extend' ? <div className='mt-4 align-items-center text-center mb-3'>
                <QRCode 
                    value={(extendResponse?.reservation && extendResponse?.reservation?.ticketech_code) ? extendResponse?.reservation?.ticketech_code : isPromoValidateButton(paymentData, ['2', '3']) ? `${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revpartnerUrl : getConfigDetails()?.partnerUrl}/admin/tickets?ticket_number=${paymentData?.ticket_number}` : paymentData?.ticket_number} 
                    size="80" 
                />
                <p className='mt-3 text-primary fw-semibold mb-0 pb-0'>{`Ticket ID - ${paymentData?.ticket_number}`}</p>
                {(isLicensePlate && paymentData?.license_plate) && <p className='mt-0 text-primary fw-semibold'>{`License Plate - ${paymentData?.license_plate}`}</p>}
                {isMessage && <small className='textColorText'>{messageSuccessPayment}</small>}
            </div> : <div className='mt-4 row mb-3'>
                <div className='col-8 text-left'>
                <p className='mt-3 text-primary fw-semibold mb-0 pb-0 small'>{`Ticket ID - ${paymentData?.ticket_number}`}</p>
                {paymentData?.license_plate && <p className='mt-0 text-primary fw-semibold small'>{`License Plate - ${paymentData?.license_plate}`}</p>}
                </div>
                <div className='col-4 text-end mb-3'>
                <QRCode 
                    value={(paymentResponse?.reservation && paymentResponse?.reservation?.ticketech_code) ? paymentResponse?.reservation?.ticketech_code : isPromoValidateButton(paymentData, ['2', '3']) ? `${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revpartnerUrl : getConfigDetails()?.partnerUrl}/admin/tickets?ticket_number=${paymentData?.ticket_number}` : paymentData?.ticket_number} 
                    size="80" 
                />
                </div>
                <small className='textColorText text-center'>{messageSuccessPayment}</small>
            </div>}
        </Container>
    )
}

QRCodeComp.propTypes = {
    dispatch: PropTypes.func,
    paymentData : PropTypes.object,
    isMessage: PropTypes.bool,
    isLicensePlate: PropTypes.bool,
    screen: PropTypes.string
}

QRCodeComp.defaulProps = {
    dispatch: noop,
    paymentData : EMPTY_OBJECT,
    isMessage: false,
    isLicensePlate: false,
    screen: undefined
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(QRCodeComp)